import React from 'react';
import { Space } from 'antd';
import { RiseOutlined, FallOutlined } from '@ant-design/icons';

function PointsChange(props) {
    if (props.player) {
        if ((typeof(props.player.lpiPreviousPoints) !== 'undefined' ? props.player.lpiPreviousPoints : 0.0) - (typeof(props.player.lpiPoints) !== 'undefined' ? props.player.lpiPoints : 0.0) > 0) {
            return (<Space style={{color: '#D80032'}}><FallOutlined />-{((typeof(props.player.lpiPreviousPoints) !== 'undefined' ? props.player.lpiPreviousPoints : 0.0) - (typeof(props.player.lpiPoints) !== 'undefined' ? props.player.lpiPoints : 0.0)).toFixed(2)}</Space>)
        } 
        if ((typeof(props.player.lpiPreviousPoints) !== 'undefined' ? props.player.lpiPreviousPoints : 0.0) - (typeof(props.player.lpiPoints) !== 'undefined' ? props.player.lpiPoints : 0.0) < 0) {
            return (<Space style={{color: '#0f5132'}}><RiseOutlined/>+{((typeof(props.player.lpiPoints) !== 'undefined' ? props.player.lpiPoints : 0.0) - (typeof(props.player.lpiPreviousPoints) !== 'undefined' ? props.player.lpiPreviousPoints : 0.0)).toFixed(2)}</Space>)
        } 
    } else {
        return <div></div>
    }
}

export default PointsChange;